var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeCloseSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0183 22.8L12.6239 22.4423L13.211 20.3675C12.3303 20.0098 11.5229 19.5805 10.8624 19.0081L9.24771 20.5821L8.22018 19.5805L9.76147 17.935C8.88073 16.8618 8.29358 15.6455 8 14.2862L9.46789 14C10.055 17.0764 12.7706 19.3659 16 19.3659C19.2294 19.3659 21.945 17.0764 22.5321 14.0715L24 14.3577C23.7798 15.7171 23.1193 16.9333 22.2385 18.0065L23.8532 19.5805L22.8257 20.5821L21.1376 19.0081C20.4037 19.5805 19.5963 20.0098 18.789 20.3675L19.3761 22.4423L17.9817 22.8L17.3945 20.7252C16.5138 20.8683 15.5596 20.8683 14.6789 20.7252C14.6055 20.6537 14.0183 22.8 14.0183 22.8Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseSmall);
export default __webpack_public_path__ + "static/media/eye-close-small.afaabefc.svg";
export { ForwardRef as ReactComponent };